var elLoader = {

  show:function(text){
    document.getElementById("elPageLoader").classList.add("show");
    var loaderText = document.getElementsByClassName("elPageLoaderText");
    for(let i = 0;i<loaderText.length;i++){
      loaderText[i].innerHTML = text;
    }



  },
  hide:function(){
    if(document.getElementById("elPageLoader")){
      document.getElementById("elPageLoader").classList.remove("show");
      var loaderText = document.getElementsByClassName("elPageLoaderText");
      for(let i = 0;i<loaderText.length;i++){
        loaderText[i].innerHTML = "";
      }
    }
  }
}

window.addEventListener("pageshow",function(){
 // elLoader.hide();
});
